import React, { useState, useEffect } from 'react';
import DesktopNavBar from '../Navbar/DesktopNavbar';
import MobileNavBar from '../Navbar/MobileNavbar';
import '../../CSS/NavBar.css';

const NavBar = () => {

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleWindowResize = () => setWidth(window.innerWidth)
        window.addEventListener("resize", handleWindowResize);

        return () => window.removeEventListener("resize", handleWindowResize);

    }, []);

    return (
        width > 400 ? 
            <DesktopNavBar />
        :
            <MobileNavBar />
    )
}

export default NavBar;